import { useTranslation } from 'react-i18next';

import { Button, RouterButton } from '@/primitives/Button';
import { Illustration } from '@/primitives/Icons';
import { getSourceConfig, useTicker } from '@/theme';

export const NotFound = ({ redirectTo }: { redirectTo?: string }) => {
  const { t } = useTranslation();

  return (
    <GenericErrorPage redirectTo={redirectTo}>
      <h3>{t('review.errors.notFound.title')}</h3>
      <p>{t('review.errors.notFound.body')}</p>
    </GenericErrorPage>
  );
};

export const Forbidden = () => {
  const { t } = useTranslation();

  return (
    <GenericErrorPage>
      <h3>{t('review.errors.accessDenied.title')}</h3>
      <p>{t('review.errors.accessDenied.body')}</p>
    </GenericErrorPage>
  );
};

const GenericErrorPage = ({
  children,
  redirectTo,
}: React.InputHTMLAttributes<HTMLInputElement> & { redirectTo?: string }) => {
  const { t } = useTranslation();
  const { backBtnUrl } = getSourceConfig();
  const ticker = useTicker();

  return (
    <div
      className="content"
      style={{
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <p style={{ width: '15rem' }}>
        <Illustration />
      </p>
      <br />
      {children}
      <br />
      {['VERDOUW', 'BOUWPROFI'].includes(ticker) ? (
        <Button href={backBtnUrl} style={{ width: '18em' }} as="a">
          {t('review.goToHome')}
        </Button>
      ) : (
        <RouterButton to={redirectTo || '/'} style={{ width: '18em' }}>
          {t('review.goToHome')}
        </RouterButton>
      )}
    </div>
  );
};
